export const dashboard = {
      title: 'Panel de inventario',
      subtitle: 'Monitorea existencias, alertas y movimientos en tiempo real',
      newMovement: 'Nuevo movimiento',
      lowStock: 'Productos con inventario bajo',
      recentMovements: 'Movimientos recientes',
      preferredUnitSwitch: 'Unidad',
      preferredUnitSwitchHint: 'Ver en unidad predeterminada.',
      availableBoxes: 'Cajas disponibles',
      productsBelowMinimum: 'Productos bajo mínimo',
      movementsToday: 'Movimientos hoy',
      boxesSoldThisWeek: 'Cajas vendidas esta semana',
      inventoryCoverage: 'Cobertura de inventario',
      inventoryTurnover: 'Rotación de inventario',
      totalInventoryBoxes: 'Piezas totales',
      inventoryValue: 'Valor del inventario',
      last7Days: 'Últimos 7 días',
      healthy: 'Saludable',
      averageCostPerBox: 'Costo prom/caja',
      weeks: 'semanas',
      turnover4Weeks: 'Rotacion 4 semanas',
    } as const;
